import { render, staticRenderFns } from "./free.vue?vue&type=template&id=158165bb&scoped=true&"
import script from "./free.vue?vue&type=script&lang=ts&"
export * from "./free.vue?vue&type=script&lang=ts&"
import style0 from "./free.vue?vue&type=style&index=0&id=158165bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158165bb",
  null
  
)

export default component.exports